import React from 'react'

export default function ComponentePaginacionTabla({ page,sizerows,pageIndex, pageOptions, pageSize, setPageSize, canPreviousPage, canNextPage, previousPage, nextPage }) {
    var totalFilas = sizerows !== undefined?sizerows:55
    return (
        <React.Fragment>
            <div className="text-right filasinfopagination">
                <span>Mostrando {page.length} de {sizerows} filas</span>
            </div>
            <div className="containerPaginacionHistorial text-right mb-2">
                <span>
                    Página{' '}
                    <strong>
                        {pageIndex + 1} de {pageOptions.length}
                    </strong>{' '}
                </span>
                <select
                    value={pageSize}
                    onChange={(e) => setPageSize(Number(e.target.value))}
                >
                    {[5, 10, 15, 25, 50,totalFilas].map((pageSize,ind) => (
                        <option key={pageSize + "nroMostrar" + ind} value={pageSize} >
                            Mostrar {pageSize === totalFilas?"Todas":pageSize}
                        </option>
                    ))}
                </select>
                <button className={canPreviousPage ? "btnAnteriorPaginacion" : "btndisabled"} onClick={() => previousPage()} disabled={!canPreviousPage}>Anterior</button>
                <button className={canNextPage ? "btnSiguientePaginacion" : "btndisabled"} onClick={() => nextPage()} disabled={!canNextPage}   >Siguiente</button>

            </div>
        </React.Fragment>

    )
}

